module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAABLCAYAAADgQt7gAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA+klEQVRoBe3b0QnCMBhF4Rvx3RHsCG5gN9FRHEU36QgdQUdwgl8KfSglYCnYm8j5IC+1xIM0moeYJIUqtas1XMQb7TNv/ZbUF9h6knSYXsjF9xHRbte0TEqpk3Se3syCdSHe5e++KpuU0s3Q8k0zf529jQvxLrkF+5J0L7D1Kuk4vxiz0UWEShtD17yVZ96FeBfiXYh3Id6FeBfiXYh3Id6FeBfiXYh3Id6FeBfiXYh3Id6FeBfiXYh34ciKC8+8C0dWRsOCuiy47yHpuWL+3x1ZkdRm5sqNduX8HFkpxt8t2FUioht/9DZT9Sef2x5U888F9jYuxFtI+gD+KPKUiJdOKwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/images/phone-alt-blk.png
// module id = 2408
// module chunks = 0